import * as yup from 'yup';

export const BigObjectiveSchema = yup.object().shape({
    bigObjective: yup
        .string()
        .ensure()
        .required('BigRock Objective is required!')
});
